import { render } from "./DeactivatedMembers.vue?vue&type=template&id=9fce554a&scoped=true"
import script from "./DeactivatedMembers.vue?vue&type=script&lang=js"
export * from "./DeactivatedMembers.vue?vue&type=script&lang=js"

import "./DeactivatedMembers.vue?vue&type=style&index=0&id=9fce554a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fce554a"]])

export default __exports__